let promise = Promise.resolve(); // Used to hold chain of typesetting calls

export function typeset(code) {
    promise = promise
        .then(() => {
            return window.MathJax.typesetPromise(code());
        })
        .catch((err) => console.log('Typeset failed: ' + err.message));
    return promise;
}
